import React, { createContext, useContext, useMemo } from "react";

const FormValidationContext = createContext({
  errors: null,
  clearPath: () => {},
});

export const FormValidationProvider = ({ errors, clearPath, children }) => {
  const value = useMemo(() => ({ errors, clearPath }), [errors, clearPath]);
  return (
    <FormValidationContext.Provider value={value}>
      {children}
    </FormValidationContext.Provider>
  );
};

const toKey = (path) => path.join(".");

export const useFieldError = (path) => {
  const { errors, clearPath } = useContext(FormValidationContext);
  const key = toKey(path);
  return {
    error: errors?.get(key),
    clear: () => clearPath(key),
  };
};

export const buildErrorMap = (zodError) => {
  const map = new Map();
  if (!zodError) return map;
  for (const issue of zodError.issues || []) {
    const key = toKey(issue.path);
    if (!map.has(key)) map.set(key, issue.message);
  }
  return map;
};

export const firstErroredSectionIndex = (zodError) => {
  if (!zodError) return -1;
  for (const issue of zodError.issues || []) {
    if (issue.path[0] === "sections" && typeof issue.path[1] === "number") {
      return issue.path[1];
    }
  }
  return -1;
};
